import type { DirectoryPageContent } from "./types";
import { INDUSTRIES, SOLUTIONS } from "../nav/navigation";

/**
 * Index pages derive their entries from the navigation, so a solution or
 * industry can only be added in one place and cannot appear in the mega-menu
 * while missing from its own directory.
 */
export const DIRECTORY_PAGES: DirectoryPageContent[] = [
  {
    path: "/solutions",
    title: "Solutions",
    eyebrow: "By outcome",
    headline: "Start from the problem you have to solve, not the product you have to buy",
    lede:
      "Six outcomes that cover most of why organizations come to us: adopting AI without losing control of it, and proving that to whoever is asking.",
    entries: SOLUTIONS,
    close: {
      heading: "Not sure which one you are",
      body:
        "Most programs start with an inventory or an incident. A briefing will tell you which of these you are actually buying.",
      ctas: [
        { label: "Request a briefing", href: "/contact?topic=solutions" },
        { label: "Explore the portfolio", href: "/products" },
      ],
    },
  },
  {
    path: "/industries",
    title: "Industries",
    eyebrow: "By sector",
    headline: "Governed AI adoption where getting it wrong is a regulatory event",
    lede:
      "The technology is the same across sectors. The obligations, the evidence and the people asking for it are not.",
    entries: INDUSTRIES,
    close: {
      heading: "Bring your regulator to the conversation",
      body:
        "Tell us which framework you are held to and we will show you the crosswalk against it rather than a generic maturity model.",
      ctas: [
        { label: "Request a briefing", href: "/contact?topic=industries" },
        { label: "Explore Warden", href: "/warden" },
      ],
    },
  },
];
